import { Edit } from "react-admin"

import { TagForm } from "./TagForm"

export const TagEdit = () => (
  <Edit mutationMode="pessimistic">
    <TagForm />
  </Edit>
)
